<template>
  <div class="pb-2">
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == true">
      <b-card>
        <div class="text-right pb-1">
          <b-button variant="primary" @click="actionImportList(0)">สร้างรายการใหม่</b-button>
        </div>
        <b-table
          responsive
          :items="importList"
          :fields="importFields"
          table-class="table-md-responsive text-nowrap"
        >
          <template #cell(rowID)="data">
            <feather-icon
              :id="`info-${data.value}`"
              icon="FileTextIcon"
              class="cursor-pointer text-info"
              size="20"
              @click="viewImportInfo(data.value)"
            />
            <b-tooltip title="รายละเอียด" :target="`info-${data.value}`" :delay="{show: '1000'}"/>

            <span v-if="data.item.importStatus == 0">
              <feather-icon
                :id="`edit-${data.value}`"
                icon="EditIcon"
                class="cursor-pointer text-warning mx-1"
                size="20"
                @click="actionImportList(data.value)"
              />
              <b-tooltip title="แก้ไข" :target="`edit-${data.value}`" :delay="{show: '1000'}"/>

              <feather-icon
                :id="`delete-${data.value}`"
                icon="Trash2Icon"
                class="cursor-pointer text-danger"
                size="20"
                @click="deleteInfoList(data.item)"
              />
              <b-tooltip title="ลบ" :target="`delete-${data.value}`" :delay="{show: '1000'}"/>
            </span>
          </template>
          <template #cell(createDate)="data">
            {{formatDatetime(data.value)}}
          </template>
          <template #cell(totalImportDuty)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(totalVat)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(totalShipping)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(descriptionTH)="data">
            {{data.value}} - {{data.item.isMakebox == false ? 'ไม่ตีลัง' : 'ตีลัง'}}
          </template>
        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BButton, BCard, BTable, BSpinner, BTooltip } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format_price, formatDatetime} from '@/views/global_function.js'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
export default {
  name: 'Taobao2youFormalImport',

  components: {
    BButton, BCard, BTable, BSpinner, BTooltip
  },

  data() {
    return {
      importList: [],
      importFields: [
        { key: 'rowID', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'createDate', label:'วันที่สร้างบิล', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'billNumber', label: 'เลขบิล', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'addressCode', label:'รหัสจ่าหน้า', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'totalImportDuty', label: 'ภาษีนำเข้า', thClass: 'text-center', tdClass: 'text-right' },
        { key: 'totalVat', label: 'ภาษีมูลค่าเพิ่ม', thClass: 'text-center', tdClass: 'text-right' },
        { key: 'totalShipping', label: 'ค่าขนส่ง', thClass: 'text-center', tdClass: 'text-right' },
        { key: 'descriptionTH', label: 'รูปแบบการจัดส่ง', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'statusText', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
      ],

      //load
      loadpage: true,
    };
  },

  async created() {
    this.checkFileCert()
  },

  methods: {
    format_price,
    formatDatetime,
    async checkFileCert() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/FileCertificate/check-file-cert',
        // "https://localhost:5001/app/FileCertificate/check-file-cert",
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
        },
        { headers: header_token }
      );
      if (response.data == false) {
        this.$swal({
          title: 'คุณยังไม่เคยอัปโหลดไฟล์ !',
          text: "กรุณาอัปโหลดไฟล์อย่างน้อย 1 ไฟล์ !",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'ไปอัปโหลดไฟล์',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then( async result => {
          if (result.value) {
            this.$router.push({path: '/me/information'})
          }
        })
      } else {
        this.loadpage = false
        await this.getImportList()
        this.loadpage = true
      }
    },
    async getImportList() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/FileCertificate/get-import-list',
        // "https://localhost:5001/app/FileCertificate/get-import-list",
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
        },
        { headers: header_token }
      );
      this.importList = response.data
    },

    async viewImportInfo (id) {
      window.open("/import/formal/information?importID=" + id, "_self");
    },

    async actionImportList(id) {
      window.open("/import/formal/action?rowID=" + id, "_self");
    },

    async deleteInfoList(item) {
      this.$swal({
        title: 'ลบรายการบิลนำเข้า ?',
        text: "คุณแน่ใจหรือไม่ว่าต้องการลบรายการบิลนำเข้า เลขที่บิล " + item.billNumber + " ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/FileCertificate/delete-import-list',
            // "https://localhost:5001/app/FileCertificate/delete-import-list",
            {
              "rowID": item.rowID,
            },
            { headers: header_token }
          );
          if (response.data == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ลบข้อมูลเรียบร้อย',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
            this.getImportList()
          }
        }
      })
    },

  },
};
</script>

<style scoped lang="scss">

</style>